module.exports = __webpack_public_path__ + "static/img/fish-bone.d8e207ca.png";